import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { types } from 'mobx-state-tree';
export const CompanyFeatureSetModel = types.model('CompanyFeatureSetModel', {
  isAppfolio: false,
  enableNewLayoutBeta: false,
  enableReimbursementReport: false,
  enableAllocationByNumberOfOccupants: false,
  disableFeeAssessmentMethod: false,
  disableReimbursementDetails: false,
  disableReports: false,
  disableDemoMode: false,
  disableEnrollResident: false,
  disablePostPayment: false,
  disableVoidStatement: false,
  disableLateFee: false,
  disableAddNewProperty: false,
  disableUnitOccupancyChange: false,
  disableRoommate: false,
  disableDeleteIncompletedProperty: false,
  disableAccountOverview: false,
  disableSendPaperInvite: false,
  disableSendReminder: false,
  disableSystemFee: false,
  disableStatementCap: false,
  disablePaperCorrespondence: false,
  disableBatchOccupancyChange: false,
  disableBatchSendReminder: false,
  disablePaperStatementFee: false,
  readOnlyLeaseDetails: false,
  readOnlyOccupancyChange: false,
  readOnlyScheduleMoveOut: false,
  readOnlyBillingStartDate: false,
  readOnlyPropertyUnitSetup: false,
  readOnlyMailingAddressUpdate: false,
  readOnlyPropertyPropertyInfo: false,
  readOnlyResidentPersonalDetails: false,
  readOnlyResidentPortalAccess: false
}).actions(store => ({
  setFeatureFlags(data) {
    try {
      Object.entries(data).forEach(_ref => {
        let _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        store["".concat(key)] = value;
      });
    } catch (error) {
      console.error('STORE ERROR > ', error);
    }
  }
}));